/* eslint-disable */
export default {
  toolTip: 'Anzeigen auf {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
